import Grid from '@mui/material/Grid';

export const practitionerCommonInformationFields = [
  {
    name: 'lastName',
    label: 'Nom du praticien :',
    type: 'text',
    placeholder: 'Ex : Dupont',
    wrapper: {component: Grid, props: {item: true, xs: 12, sm: 6}},
    required: true
  },
  {
    name: 'firstName',
    label: 'Prénom du praticien :',
    type: 'text',
    placeholder: 'Ex : Louise',
    wrapper: {component: Grid, props: {item: true, xs: 12, sm: 6}},
    required: true
  },
  {
    name: 'gender',
    label: 'Genre :',
    type: 'radio',
    wrapper: {component: Grid, props: {item: true, xs: 12, sm: 6}},
    options: [
      {value: 'male', label: 'Homme'},
      {value: 'female', label: 'Femme'}
    ],
    required: true
  },
  {
    name: 'avgAppointmentDelay',
    label: 'Délai moyen pour obtenir un premier rendez-vous :',
    placeholder: 'Ex : 3',
    type: 'number',
    end: 'Jour(s)',
    wrapper: {component: Grid, props: {item: true, xs: 12, sm: 6}},
    required: true
  }
];
